import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/login'
import loginEn from '@/components/login/loginEn'
import superLogin from '@/components/login/superLogin'

Vue.use(Router)
// // 获取原型对象上的push函数
// const originalPush = Router.prototype.push
// // 修改原型对象中的push方法
// Router.prototype.push = function push(location) {
//     return originalPush.call(this, location).catch(err => err)
// }

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'login',
            component: () => import('@/components/login/login'),
            meta: {
                title: '登录（中文）'
            }
        },
        {
            path: '/#/',
            name: 'login2',
            component: () => import('@/components/login/login'),
            meta: {
                title: '登录（中文）'
            }
        },

        {
            path: '/superlogin',
            name: 'superLogin',
            component: () => import('@/components/login/superLogin'),
            meta: {
                title: '超级登录'
            }
        },
        {
            path: '/#/superlogin',
            name: 'superLogin2',
            component: () => import('@/components/login/superLogin'),
            meta: {
                title: '超级登录'
            }
        },

        {
            path: '/tokenlogin',
            name: 'tokenLogin',
            component: () => import('@/components/login/tokenLogin'),
            meta: {
                title: 'tokenlogin'
            }
        },
        {
            path: '/#/tokenlogin',
            name: 'tokenLogin2',
            component: () => import('@/components/login/tokenLogin'),
            meta: {
                title: 'tokenlogin'
            }
        },

        {
            path: '/login/register',
            name: 'register',
            component: () => import('@/components/login/register'),
            meta: {
                title: '注册（中文）'
            }
        },
        {
            path: '/#/login/register',
            name: 'register2',
            component: () => import('@/components/login/register'),
            meta: {
                title: '注册（中文）'
            }
        },

        {
            path: '/login/registerSuccess',
            name: 'registerSuccess',
            component: () => import('@/components/login/registerSuccess'),
            meta: {
                title: '注册（中文）成功'
            }
        },
        {
            path: '/#/login/registerSuccess',
            name: 'registerSuccess2',
            component: () => import('@/components/login/registerSuccess'),
            meta: {
                title: '注册（中文）成功'
            }
        },

        {
            path: '/login/loginEn',
            name: 'loginEn',
            component: () => import('@/components/login/loginEn'),
            meta: {
                title: '登录（英文）'
            }
        },
        {
            path: '/#/login/loginEn',
            name: 'loginEn2',
            component: () => import('@/components/login/loginEn'),
            meta: {
                title: '登录（英文）'
            }
        },

        {
            path: '/login/registerEn',
            name: 'registerEn',
            component: () => import('@/components/login/registerEn'),
            meta: {
                title: '注册（英文）'
            }
        },
        {
            path: '/#/login/registerEn',
            name: 'registerEn2',
            component: () => import('@/components/login/registerEn'),
            meta: {
                title: '注册（英文）'
            }
        },

        {
            path: '/login/registerSuccessEn',
            name: 'registerSuccessEn',
            component: () => import('@/components/login/registerSuccessEn'),
            meta: {
                title: '注册（英文）成功'
            }
        },
        {
            path: '/#/login/registerSuccessEn',
            name: 'registerSuccessEn2',
            component: () => import('@/components/login/registerSuccessEn'),
            meta: {
                title: '注册（英文）成功'
            }
        },

        {// tabbar首页
            path: '/home',
            name: 'home',
            component: () => import('@/controller/AccountViewController'),
            meta: {
            }
        },
        {// tabbar首页
            path: '/#/home',
            name: 'home2',
            component: () => import('@/controller/AccountViewController'),
            meta: {
            }
        },
        {// 开具发票页面
            path: '/account/invoicemodel',
            name: 'invoicemodel',
            component: () => import('@/controller/InvoiceViewController'),
            meta: {
            }
        },
        {// 企业账户总览
            path: '/account/accountmodel',
            name: 'accountmodel',
            component: () => import('@/controller/AccountViewController'),
            meta: {
            }
        },
        {// 企业账户总览
            path: '/#/account/accountmodel',
            name: 'accountmodel2',
            component: () => import('@/controller/AccountViewController'),
            meta: {
            }
        },

        {// 企业账户总览==>充值
            path: '/account/entrechargemodel',
            name: 'entrechargemodel',
            component: () => import('@/controller/EntRechargeViewController'),
            meta: {
            }
        },
        {// 企业账户总览==>充值
            path: '/#/account/entrechargemodel',
            name: 'entrechargemodel2',
            component: () => import('@/controller/EntRechargeViewController'),
            meta: {
            }
        },

        {// 企业账户==》转账
            path: '/account/transferAccountsmodel',
            name: 'transferAccountsmodel',
            component: () => import('@/controller/TransferAccountsController'),
            meta: {
            }
        },

        {// 企业账户总览===>购买会员
            path: '/account/membermodel',
            name: 'membermodel',
            component: () => import('@/controller/MemberControllerView'),
            meta: {
            }
        },
        {// 企业账户总览===>购买会员
            path: '/#/account/membermodel',
            name: 'membermodel2',
            component: () => import('@/controller/MemberControllerView'),
            meta: {
            }
        },

        {// 企业账户总览===>交易明细
            path: '/account/enterprisedetailmodel',
            name: 'enterprisedetailmodel',
            component: () => import('@/controller/EntDetailViewController'),
            meta: {
            }
        },
        {// 企业账户总览===>交易明细
            path: '/#/account/enterprisedetailmodel',
            name: 'enterprisedetailmodel2',
            component: () => import('@/controller/EntDetailViewController'),
            meta: {
            }
        },

        {// 企业关联账号管理
            path: '/account/managementmodel',
            name: 'managementmodel',
            component: () => import('@/controller/ManagementViewController'),
            meta: {
            }
        },
        {// 企业关联账号管理
            path: '/#/account/managementmodel',
            name: 'managementmodel2',
            component: () => import('@/controller/ManagementViewController'),
            meta: {
            }
        },

        {// 个人账户总览
            path: '/account/personalmodel',
            name: 'personalmodel',
            component: () => import('@/controller/PersonalViewController'),
            meta: {
            }
        },
        {// 个人账户总览
            path: '/#/account/personalmodel',
            name: 'personalmodel2',
            component: () => import('@/controller/PersonalViewController'),
            meta: {
            }
        },

        {// 个人账户总览==>充值
            path: '/account/rechargemodel',
            name: 'rechargemodel',
            component: () => import('@/controller/RechargeViewController'),
            meta: {
            }
        },
        {// 个人账户总览==>充值
            path: '/#/account/rechargemodel',
            name: 'rechargemodel2',
            component: () => import('@/controller/RechargeViewController'),
            meta: {
            }
        },

        {// 个人账户==》转账
            path: '/account/personalTransfermodel',
            name: 'personalTransfermodel',
            component: () => import('@/controller/PersonalAccountsController'),
            meta: {
            }
        },

        {// 个人账户总览==>充值明细
            path: '/account/personaldetailmodel',
            name: 'personaldetailmodel',
            component: () => import('@/controller/PerDetailViewController'),
            meta: {
            }
        },
        {// 个人账户总览==>充值明细
            path: '/#/account/personaldetailmodel',
            name: 'personaldetailmodel2',
            component: () => import('@/controller/PerDetailViewController'),
            meta: {
            }
        },

        {// 支付宝充值页面
            path: '/payGateWay',
            name: 'payGateWay',
            component: () => import('@/alipayPage/payGateWay')
        },
        {// 支付宝充值页面
            path: '/#/payGateWay',
            name: 'payGateWay2',
            component: () => import('@/alipayPage/payGateWay')
        },

        {// 通用支付页面
            path: '/pay',
            name: 'pay',
            component: () => import('@/controller/PayViewController'),
            meta: {
                keepAlive: false
            }
        },
        {// 通用支付页面
            path: '/#/pay',
            name: 'pay2',
            component: () => import('@/controller/PayViewController'),
            meta: {
                keepAlive: false
            }
        },

        {// 通用支付结果页面
            path: '/payresult',
            name: 'payresult',
            component: () => import('@/controller/PayResultController'),
            meta: {
            }
        },
        {// 通用支付结果页面
            path: '/#/payresult',
            name: 'payresult2',
            component: () => import('@/controller/PayResultController'),
            meta: {
            }
        },

        {// 快捷支付页面
            path: '/quickpay',
            name: 'quickpay',
            component: () => import('@/controller/QuickPayController'),
            meta: {
            }
        },
        {// 快捷支付页面
            path: '/#/quickpay',
            name: 'quickpay',
            component: () => import('@/controller/QuickPayController'),
            meta: {
            }
        },

        {// 快捷支付页面(英文版)
            path: '/quickpayen',
            name: 'quickpayen',
            component: () => import('@/controller/QuickPayEnController'),
            meta: {
            }
        },
        {// 快捷支付页面(英文版)
            path: '/#/quickpayen',
            name: 'quickpayen',
            component: () => import('@/controller/QuickPayEnController'),
            meta: {
            }
        },

        {// Paypal支付结果页面
            path: '/paypalresult',
            name: 'paypalresult',
            component: () => import('@/controller/PaypalResultController'),
            meta: {
            }
        },
        {// Paypal支付结果页面
            path: '/#/paypalresult',
            name: 'paypalresult2',
            component: () => import('@/controller/PaypalResultController'),
            meta: {
            }
        },

        {// 快捷支付结果页面
            path: '/quickpayresult',
            name: 'quickpayresult',
            component: () => import('@/controller/QuickPayResultController'),
            meta: {
            }
        },
        {// 快捷支付结果页面
            path: '/#/quickpayresult',
            name: 'quickpayresult',
            component: () => import('@/controller/QuickPayResultController'),
            meta: {
            }
        },

        {// 快捷支付结果页面(英文版)
            path: '/quickpayenresult',
            name: 'quickpayenresult',
            component: () => import('@/controller/QuickPayEnResultController'),
            meta: {
            }
        },
        {// 快捷支付结果页面(英文版)
            path: '/#/quickpayenresult',
            name: 'quickpayenresult',
            component: () => import('@/controller/QuickPayEnResultController'),
            meta: {
            }
        },

        {// 快捷支付联系人页面
            path: '/quickpaycontact',
            name: 'quickpaycontact',
            component: () => import('@/controller/QuickPayContactController'),
            meta: {
            }
        },
        {// 快捷支付联系人页面
            path: '/#/quickpaycontact',
            name: 'quickpaycontact',
            component: () => import('@/controller/QuickPayContactController'),
            meta: {
            }
        },

        {// 快捷支付联系人页面(英文版)
            path: '/quickpayencontact',
            name: 'quickpayencontact',
            component: () => import('@/controller/QuickPayEnContactController'),
            meta: {
            }
        },
        {// 快捷支付联系人页面(英文版)
            path: '/#/quickpayencontact',
            name: 'quickpayencontact',
            component: () => import('@/controller/QuickPayEnContactController'),
            meta: {
            }
        }
    ]
})
